export const isEmail = (email: string | null | undefined) => {
  if (!email) {
    return false;
  }
  const emailRegex = new RegExp(VALID_EMAIL_REGEX);
  return email.match(emailRegex);
};

// TODO - Use a more robust library like google-libphonenumber
export const isPhoneNumber = (phoneNumber: string | null | undefined) => {
  if (!phoneNumber) {
    return false;
  }
  /*
  If this is already in E.164 format, it's a phone number
   */
  if (/^\+1[\d]{10}$/g.test(phoneNumber)) {
    return true;
  }
  const matchNumbers = phoneNumber.match(/\d/g);
  const matchLetters = phoneNumber.match(/[A-Za-z]/g);
  if (
    phoneNumber.length > 20 ||
    (matchLetters && matchLetters.length > 0) ||
    !matchNumbers ||
    matchNumbers.length !== 10
  ) {
    return false;
  }

  return true;
};

export const isValidString = (stringToTest: string | null | undefined) =>
  stringToTest && stringToTest.trim().length > 0;

/**
 * Regex that validates teh general shape of EINs - lifted from https://stackoverflow.com/a/49790281
 * Note: this doesn't necessarily mean the EIN is real/correct, just that the first two numbers are valid
 * and it's the correct length
 */
export const EIN_REGEX = () => /^(?![01][789]|2[89]|[46]9|7[089]|89|9[67])\d\d-\d{7}$/g;
export const ZIP_CODE_REGEX = () => /(^\d{5}$)|(^\d{5}-\d{4}$)/g;

export const ALL_UPPERCASE_LETTERS_REGEX = /^[A-Z](\s?[A-Z]\s?)*$/;
export const SPECIAL_CHARACTERS_REGEX = /[$!*]+/;
export const VALID_5_DIGIT_ZIP_CODE_REGEX = /^\d{5}$/;
// This is a different zip code regex than the ZIP_CODE_REGEX above as the other one was causing issues with form validation
// We should clean up the zip code validation to align our functionality
export const VALID_5_OR_9_DIGIT_ZIP_CODE_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
export const VALID_EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/gi;

export const isZipCode = (zipCode: string | null | undefined) => {
  if (zipCode && zipCode.match(ZIP_CODE_REGEX())) {
    return true;
  }
  return false;
};

export const isValidHttpUrl = (url: string | null | undefined) => {
  if (!url) {
    return false;
  }
  let urlTest;

  try {
    urlTest = new URL(url);
  } catch (_) {
    return false;
  }

  return urlTest.protocol === 'http:' || urlTest.protocol === 'https:';
};
